module.exports = __webpack_public_path__ + "static/media/1_19_1.fed574f4.jpg";